module.exports = __webpack_public_path__ + "img/bg.ae5d01fb.svg";